import {z} from "zod/v4-mini"
import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {AddressMode, size2Like} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/basic-definitions"
import {interpolationMode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/hal/resize-helper-hal"

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.object({
            sourceImage: anyImageOpResult,
            resultSize: size2Like,
            interpolationMode: z._default(interpolationMode, "cubic"),
            addressMode: z._default(AddressMode, "clamp"),
        }),
    },
}
